import { FC, Dispatch, ReactNode, SetStateAction, useContext, createContext } from "react";
import { SegmentCountType } from "src/constants/filters";
import { SearchFormInputs } from "../../../constants/SearchPage";

type HotelsListingContextType = {
  searchObject: SearchFormInputs;
  filters: any;
  setFilters: Dispatch<SetStateAction<any>>;
  sorter: any;
  setSorter: Dispatch<SetStateAction<any>>;
  dataCount: SegmentCountType;
  isFetching: boolean;
  isPollingDone: boolean;
  hasFirstResults: boolean;
  pointsFactor: number;
  sessionId: string;
};
const HotelsListingContext = createContext<HotelsListingContextType | null>(null);

const HotelsListingProvider: FC<{ children: ReactNode; value: HotelsListingContextType }> = ({ children, value }) => {
  return <HotelsListingContext.Provider value={value}>{children}</HotelsListingContext.Provider>;
};

export default HotelsListingProvider;

export const useHotelsListingContext = () => {
  const context = useContext(HotelsListingContext);
  if (!context) throw new Error("Invalid usage outside of context");
  return context;
};
